<div class="tenor-selector"
     [class.tenor-selector-active]="activeTenor === tenor"
     (click)="onTenorSelect()">
    <span>{{'insights.tenor.' + tenor | translate}}</span>
</div>
